import { useRouteError } from "react-router-dom";
import { RequestIdBadge } from "./RequestIdBadge.js";

export function RouteErrorBoundary() {
  const error = useRouteError() as {
    message?: string;
    requestId?: string;
    meta?: { requestId?: string };
  };
  const requestId = error?.requestId ?? error?.meta?.requestId;
  return (
    <div style={{ padding: "2rem", color: "#f1f5f9" }}>
      <h2 style={{ marginBottom: "0.5rem" }}>Something went wrong</h2>
      <p style={{ color: "#94a3b8", marginBottom: "1rem" }}>
        {error?.message ?? "An unexpected error occurred."}
      </p>
      {requestId && <RequestIdBadge requestId={requestId} />}
    </div>
  );
}
